<template>
    <div class="flex-grid">
        <div class="flex-xl-6">
            <p>
                Minas Gerais é uma mistura batuta de música, montanhas, clima, arquitetura, pessoas,
                sotaques e sabores. Minas é muito mais que divisão territorial: é o nosso estado de
                espírito!
            </p>
            <p>
                Temos orgulho dessa terra fértil de boas ideias, por isso gritamos para o mundo em
                prosa e poesia numa ode constante a esse mar de morros: é desses contornos que
                tiramos nossa inspiração; sem Minas, não tem Chico Rei!
            </p>
            <p>
                O orgulho de nossas raízes vai transbordando, ficando mais e mais evidente… Ao ponto
                de se transformar numa inquietude que fez nascer o que temos de mais básico: a nossa
                marca.
            </p>
            <p>
                Resgatamos formas orgânicas, maleáveis e disfuncionais das montanhas de Minas porque
                é nisso que acreditamos: enquanto indivíduos, somos grandiosos, complexos em nossas
                nuances e singularidades. Ainda que parecidos, somos únicos. E veja só: nenhuma
                montanha é igual a outra.
            </p>
            <p>
                A sinergia de nossos valores, propósito e história se materializam de forma visual
                em dois elementos básicos: objeto e texto. Seja de forma conjunta ou
                individualmente, o objetivo é representar de forma imagética o conceito “De Minas
                para o Mundo”, que norteia o trabalho da Chico Rei.
            </p>
        </div>
        <BrandBookGallery class="flex-xl-6" :images="images" :square="true" :add-padding="true" />
    </div>
</template>

<script>
    import BrandBookHeading from '../BrandBookHeading';
    import BrandBookGallery from '../../brand-book-6/sections/BrandBookGallery';

    export default {
        name: 'BrandBookLogo',

        components: { BrandBookGallery, BrandBookHeading },

        data() {
            return {
                images: [
                    {
                        src: 'logo/2021_Chico_Rei_logo_01.svg',
                        alt: 'Logomarca 1',
                    },
                    {
                        src: 'logo/2021_Chico_Rei_logo_02.svg',
                        alt: 'Logomarca 2',
                    },
                    {
                        src: 'logo/2021_Chico_Rei_logo_03.svg',
                        alt: 'Logomarca 3',
                    },
                    {
                        src: 'logo/2021_Chico_Rei_logo_04.svg',
                        alt: 'Logomarca 4',
                    },
                    {
                        src: 'logo/2021_Chico_Rei_logo_05.svg',
                        alt: 'Logomarca 5',
                    },
                ],
            };
        },
    };
</script>
